const { usableValue } = require('./usable-value')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {object} obj
 * @param {(array|string|object)} subItems
 * @returns {(string|object|null)}
 */
function getProp (obj, ...subItems) {
  if (!obj) {
    return null
  }

  let currentObject = obj

  for (let i = 0; i < subItems.length; i++) {
    if (!usableValue(currentObject[subItems[i]])) {
      return null
    }

    currentObject = currentObject[subItems[i]]
  }

  return currentObject
}

module.exports = { getProp }
